import axios from "axios";
import headers from "./Header";
import { getStatusAliasModaPengirimanPMSE } from '../utils/commonUtils'
// import header from "./Header";
let url = "/pmse";
class PmseService {
  MODA_STATUS = {
    STATUS_EFORM_OPEN: 0,
    STATUS_EFORM_SUBMIT: 2,
    STATUS_EFORM_DRAFT: 18,
    STATUS_KUNJUNGAN_OPEN: 3,
    STATUS_KUNJUNGAN_UPLOAD: 12,
    STATUS_KUNJUNGAN_REJECT: 13,
    STATUS_KUNJUNGAN_VALIDASI: 4,
    STATUS_KUNJUNGAN_DONE: 5,
    STATUS_UNGGAH_OPEN: 6,
    STATUS_UNGGAH_UPLOAD: 10,
    STATUS_UNGGAH_REJECT: 11,
    STATUS_UNGGAH_VALIDASI: 7,
    STATUS_UNGGAH_DONE: 8,
    STATUS_M2M_OPEN: 9,
    STATUS_M2M_UPLOAD: 14,
    STATUS_M2M_REJECT: 15,
    STATUS_M2M_VALIDASI: 16,
    STATUS_M2M_DONE: 17,
  };

  updateTimeInput(id) {
    return axios.get(url + "/eform/update-time-input/" + id, {
      headers: headers(),
    });
  }

  // eslint-disable-next-line no-unused-vars
  getModaStatus(item) {
    return getStatusAliasModaPengirimanPMSE(item.status)
  }

  isSudahProses(item) {
    if (item.status == null) return false;
    switch (item.status) {
      case this.MODA_STATUS.STATUS_EFORM_OPEN:
        return false;
      case this.MODA_STATUS.STATUS_KUNJUNGAN_OPEN:
        return false;
      case this.MODA_STATUS.STATUS_UNGGAH_OPEN:
        return false;
      case this.MODA_STATUS.STATUS_M2M_OPEN:
        return false;
    }
    return true;
  }

  isDoneSubmitted(item) {
    switch (item.status) {
      case this.MODA_STATUS.STATUS_EFORM_OPEN:
        return false;
      case this.MODA_STATUS.STATUS_EFORM_DRAFT:
        return false;
      case this.MODA_STATUS.STATUS_EFORM_SUBMIT:
        return true;
      case this.MODA_STATUS.STATUS_KUNJUNGAN_OPEN:
        return false;
      case this.MODA_STATUS.STATUS_KUNJUNGAN_VALIDASI:
        return true;
      case this.MODA_STATUS.STATUS_KUNJUNGAN_DONE:
        return true;
      case this.MODA_STATUS.STATUS_UNGGAH_OPEN:
        return false;
      case this.MODA_STATUS.STATUS_UNGGAH_UPLOAD:
        return true;
      case this.MODA_STATUS.STATUS_KUNJUNGAN_UPLOAD:
        return true;
      case this.MODA_STATUS.STATUS_UNGGAH_REJECT:
        return false;
      case this.MODA_STATUS.STATUS_M2M_REJECT:
        return false;
      case this.MODA_STATUS.STATUS_KUNJUNGAN_REJECT:
        return false;
      case this.MODA_STATUS.STATUS_UNGGAH_VALIDASI:
        return true;
      case this.MODA_STATUS.STATUS_UNGGAH_DONE:
        return true;
      case this.MODA_STATUS.STATUS_M2M_OPEN:
        return true;
    }
  }

  getListQuestionerSelection(id) {
    if (id) {
      return axios.get(url + "/questioner-selection/" + id, {
        headers: headers(),
      });
    } else {
      return axios.get(url + "/questioner-selection", {
        headers: headers(),
      });
    }
  }

  cekIsEmailExist(email) {
    return axios.post(url + "/data-perusahaan/is_exist_email", { email });
  }

  getAssignmentStatus(ids) {
    return axios.post(
      url + "/dashboard/get_assignment_status",
      { ids },
      {
        headers: headers(),
      }
    );
  }
  forgotPassword(email) {
    return axios.post("api/forgotpassword/", email);
  }
  verifyForgotPassword(code) {
    return axios.get("api/verify-forgotpassword/?code=" + code);
  }
  resetPassword(data) {
    return axios.put("api/change-password", data);
  }
  changePasswordAuth(data) {
    return axios.put("api/change-password-auth", data, {
      headers: headers(),
    });
  }
  getQuestionerSelection(periode) {
    return axios.get(
      url + "/questioner-selection/user-active?periode=" + periode,
      {
        headers: headers(),
      }
    );
  }

  getQuestionerSelectionByUser(id) {
    return axios.get(url + "/questioner-selection/user/" + id, {
      headers: headers(),
    });
  }

  postQuestionSelection(data) {
    return axios.post(url + "/questioner-selection/add", data, {
      headers: headers(),
    });
  }
  deleteQuestionerSelection(idPeriode) {
    return axios.delete(
      url + "/questioner-selection/delete-self/" + idPeriode,
      {
        headers: headers(),
      }
    );
  }

  getListModeSelection(id) {
    if (id) {
      return axios.get(url + "/mode-selection/" + id, {
        headers: headers(),
      });
    } else {
      return axios.get(url + "/mode-selection", {
        headers: headers(),
      });
    }
  }

  getModeSelection(periode) {
    return axios.get(url + "/mode-selection/user-active?periode=" + periode, {
      headers: headers(),
    });
  }

  getModeSelectionByUser(id) {
    return axios.get(url + "/mode-selection/user/" + id, {
      headers: headers(),
    });
  }

  postModeSelection(data) {
    return axios.post(url + "/mode-selection/add", data, {
      headers: headers(),
    });
  }

  deleteModeSelection(id) {
    return axios.delete(url + "/mode-selection/" + id, {
      headers: headers(),
    });
  }

  getDashboardUser() {
    return axios.get(url + "/dashboard/user", {
      headers: headers(),
    });
  }
  getDashboardDocumentCross(idPeriode) {
    return axios.get(url + "/dashboard/document-cross/" + idPeriode, {
      headers: headers(),
    });
  }

  getAssignments(assignmentIds) {
    return axios.post(
      url + "/dashboard/assignments-by-ids",
      { ids: assignmentIds },
      {
        headers: headers(),
      }
    );
  }

  getAssignment(assignmentId) {
    return axios.post(
      url + "/dashboard/assignment-by-id",
      { ids: [assignmentId] },
      {
        headers: headers(),
      }
    );
  }

  getDashboardDocumentSeries(periode) {
    return axios.post(url + "/dashboard/cross-series", periode, {
      headers: headers(),
    });
  }

  downloadDocumentByPerusahaanPeriodeId(id) {
    return axios.post(
      url + "/webdav/download",
      { perusahaanPeriodeId: id },
      {
        headers: headers(),
      }
    );
  }

  getDocument(type, periode) {
    if (type) {
      return axios.get(
        "/document/pmse-user?type=" + type + "&periode=" + periode,
        {
          headers: headers(),
        }
      );
    } else {
      return axios.get("/document/pmse-user?periode=" + periode, {
        headers: headers(),
      });
    }
  }

  getDocumentById(id) {
    return axios.get("/pmse/webdav/download/" + id, {
      headers: headers(),
      responseType: 'arraybuffer'
    });
  }

  getDocumentByUser(periode, idUser) {
    return axios.get(
      "/document/pmse-admin?project=pmse&periode=" +
        periode +
        "&user=" +
        idUser,
      {
        headers: headers(),
      }
    );
  }

  postDocument(data) {
    return axios.post("/document/add", data, {
      headers: headers(),
    });
  }

  delDocument(data) {
    return axios.delete("/document/delete", {
      headers: headers(),
      data: data,
    });
  }

  infoFile(path) {
    return axios.get(url + "/webdav/list?path=" + path, {
      headers: headers(),
    });
  }

  downloadFile(data) {
    return axios.post(url + "/ocs/download", data, {
      headers: headers(),
    });
  }

  uploadFile(form_data, path) {
    return axios.put(url + "/webdav?path=" + path, form_data, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("vuex")).auth.token,
        "Content-Type": "multipart/form-data",
      },
    });
  }

  deleteFile(path) {
    return axios.delete(url + "/webdav?path=" + path, {
      headers: headers(),
    });
  }

  deleteProfil(id) {
    return axios.delete(url + "/data-perusahaan/delete/" + id, {
      headers: headers(),
    });
  }
  updateProfil(data) {
    return axios.post(url + "/data-perusahaan/save", data, {
      headers: headers(),
    });
  }
  approvePerusahaan(data) {
    return axios.put(url + "/data-perusahaan/approve", data, {
      headers: headers(),
    });
  }
  rejectProfil(data) {
    return axios.put(url + "/data-perusahaan/reject", data, {
      headers: headers(),
    });
  }

  getProfil(id) {
    return axios.get(url + "/data-perusahaan/get/" + id, {
      headers: headers(),
    });
  }
  getSelfProfil() {
    return axios.get(url + "/data-perusahaan/get-self/", {
      headers: headers(),
    });
  }
  getSelfProfilKl() {
    return axios.get(url + "/user-kl/get-self/", {
      headers: headers(),
    });
  }
  updateProfilKl(data) {
    return axios.put(url + "/user-kl/update-self/", data, {
      headers: headers(),
    });
  }
  getSelfProfilBps() {
    return axios.get(url + "/user-bps/get-self/", {
      headers: headers(),
    });
  }

  getAllProfilPerusahaan() {
    return axios.get(url + "/data-perusahaan/all", {
      headers: headers(),
    });
  }
  getPeriodes() {
    return axios.get(url + "/periode/", {
      headers: headers(),
    });
  }
  getPeriodesActive() {
    return axios.get(url + "/periode/active/", {
      headers: headers(),
    });
  }

  getPeriodesActiveByPerusahaan() {
    return axios.get(url + "/periode/active-perusahaan", {
      headers: headers(),
    });
  }
  addPeriode(data) {
    return axios.post(url + "/periode/add", data, {
      headers: headers(),
    });
  }
  savePeriode(data) {
    return axios.put(url + "/periode/save", data, {
      headers: headers(),
    });
  }
  deletePeriode(id) {
    return axios.delete(url + "/periode/delete/" + id, {
      headers: headers(),
    });
  }
  getApprovalData() {
    return axios.get(url + "/approval-data/", {
      headers: headers(),
    });
  }
  getApprovalDataByPeriode(idPeriode) {
    return axios.get(url + "/approval-data/" + idPeriode, {
      headers: headers(),
    });
  }
  approveData(data) {
    return axios.put(url + "/approval-data/approve", data, {
      headers: headers(),
    });
  }
  updateModaStatus(data) {
    return axios.put(url + "/approval-data/update-status", data, {
      headers: headers(),
    });
  }
  tolakData(data) {
    return axios.put(url + "/approval-data/tolak", data, {
      headers: headers(),
    });
  }
  validasiData(data) {
    return axios.put(url + "/approval-data/validasi", data, {
      headers: headers(),
    });
  }
  getAllKunjungan() {
    return axios.get(url + "/kunjungan/get-all/", {
      headers: headers(),
    });
  }
  getSelfKunjungan(idPeriode) {
    return axios.get(url + "/kunjungan/get-self/" + idPeriode, {
      headers: headers(),
    });
  }
  getKunjunganByPeriode(idPeriode) {
    return axios.get(url + "/kunjungan/get-by-periode/" + idPeriode, {
      headers: headers(),
    });
  }
  getKunjungan(id) {
    return axios.get(url + "/kunjungan/get/" + id, {
      headers: headers(),
    });
  }
  saveKunjungan(data) {
    return axios.post(url + "/kunjungan/add", data, {
      headers: headers(),
    });
  }
  editKunjungan(data) {
    return axios.put(url + "/kunjungan/edit", data, {
      headers: headers(),
    });
  }
  replaceKunjungan(data) {
    return axios.put(url + "/kunjungan/replace", data, {
      headers: headers(),
    });
  }
  approveKunjungan(data) {
    return axios.put(url + "/kunjungan/approve", data, {
      headers: headers(),
    });
  }
  batalApproveKunjungan(data) {
    return axios.put(url + "/kunjungan/batalApprove", data, {
      headers: headers(),
    });
  }
  getIcsLink(data) {
    return axios.post(url + "/eform/get-link", data, {
      headers: headers(),
    });
  }
  checkLink(data) {
    return axios.post(url + "/eform/check", data, { headers: headers() });
  }
  icsLogin() {
    return axios.get(url + "/eform/ics-login", { headers: headers() });
  }
  createEform(data) {
    return axios.post(url + "/eform/create", data, { headers: headers() });
  }
  updateIcsToken(data) {
    return axios.put(url + "/eform/update-ics-token", data, {
      headers: headers(),
    });
  }
  getAllKl() {
    return axios.get(url + "/kl/", { headers: headers() });
  }
  addKL(data) {
    return axios.post(url + "/kl/add", data, { headers: headers() });
  }
  saveKL(data) {
    return axios.put(url + "/kl/edit", data, { headers: headers() });
  }
  deleteKL(id) {
    return axios.delete(url + "/kl/delete/" + id, { headers: headers() });
  }
  getAllKontakBps() {
    return axios.get(url + "/kontakbps/", { headers: headers() });
  }
  addKontakBps(data) {
    return axios.post(url + "/kontakbps/add", data, { headers: headers() });
  }
  saveKontakBps(data) {
    return axios.put(url + "/kontakbps/edit", data, { headers: headers() });
  }
  deleteKontakBps(id) {
    return axios.delete(url + "/kontakbps/delete/" + id, {
      headers: headers(),
    });
  }
  getKontakBpsByName(name) {
    return axios.get(url + "/kontakbps/?name=" + name, { headers: headers() });
  }
  getAllPusatBantuan() {
    return axios.get(url + "/pusatbantuan/", { headers: headers() });
  }
  addPusatBantuan(data) {
    return axios.post(url + "/pusatbantuan/add", data, { headers: headers() });
  }
  tindakLanjutiPusatBantuan(data) {
    return axios.post(url + "/pusatbantuan/tindaklanjuti", data, {
      headers: headers(),
    });
  }
  //
  getReminder(id_periode) {
    return axios.post(
      url + "/reminder/all",
      { id_periode },
      { headers: headers() }
    );
  }

  getMessage(id) {
    return axios.post(
      url + "/reminder/get-message",
      { id },
      { headers: headers() }
    );
  }

  getHistory(id) {
    return axios.get(url + "/reminder/get-history/" + id, {
      headers: headers(),
    });
  }

  getAnswerByModeSelectionId(mode_selection_id) {
    return axios.get(
      url + "/eform/get-answer-by-assignment-id/" + mode_selection_id,
      { headers: headers() }
    );
  }

  sendNotification(id) {
    return axios.post(
      url + "/reminder/send-notification",
      { id },
      { headers: headers() }
    );
  }

  getDetailPerusahaan(id) {
    return axios.get(url + "/data-perusahaan/info/" + id, {
      headers: headers(),
    });
  }
}

export default new PmseService();
